<template>
   <div class="add-progress-bucket container-fluid"> 
        <div class="row margin-top-3Perc" v-for="currentOption in totalOptions" :key="currentOption"> 
          <div class="col-md-5 col-lg-5 padding-left-0px padding-right-0px">
            <div class="form-group">
              <input type="text" placeholder="BUCKET NAME" class="form-control " v-model="tempOptionArr[currentOption - 1].ProgressBucketName" maxlength="1024"/>
            </div>
          </div>
          <div class="col-md-4 col-lg-4 padding-right-0px">
            <div class="col-md-6 col-lg-6 padding-left-0px">
              <div class="form-group">
                <input type="number" placeholder="MIN" min="0" max="100" class="form-control" v-model="tempOptionArr[currentOption - 1].MinValue"/>
              </div>
            </div>
            <div class="col-md-6 col-lg-6 padding-left-0px">
              <div class="form-group">
                <input type="number" placeholder="MAX"  min="0" max="100" class="form-control" v-model="tempOptionArr[currentOption - 1].MaxValue"/>
              </div>
            </div>
          </div>
          <div class="col-md-1 col-lg-1 padding-top-0Point6Perc">
            <span class="glyphicon glyphicon-plus-sign cursor-pointer padding-left-0px padding-right-0px" @click="addNewOption" v-if="tempOptionArr[currentOption - 1].AllowToAddNextBucket"></span>            
          </div>
          <div class="col-md-1 col-lg-1 padding-top-0Point6Perc">
            <span class="glyphicon glyphicon-minus-sign cursor-pointer" @click="removeOption($event,currentOption)"></span>
            <span class="col-md-4 col-lg-4"></span>
          </div>  
        </div> 
        <alert-box v-if="showAlertDialog" v-bind:errorMsg="errorMsg" @showAlertBox="updateShowAlertDialogFlag"></alert-box>
        <confirmation-alert v-if="showConfirmationBox" v-bind:dataObj="null" v-bind:prefixString="prefixString" v-bind:postfixString="postString" @showConfirmationBox="updateShowConfirmationAlertFlag"></confirmation-alert>
  </div>
</template>
<script>
import AlertBox from '@/components/AlertOverlay'
import ConfirmationOverlay from '@/components/ConfirmationOverlay'
import lodash from 'lodash'
export default {
  props: ['maxActionCount', 'minActionCount', 'maxElectiveEnrollmentCount', 'cohortName', 'groupName', 'createBtnPressed', 'certificateTitle', 'certificationDate', 'showUnreleasedModuleMessage', 'unreleasedModuleMessage'],
  name: 'add-progress-bucket',
  created () {
    this.addprogressBucketObjOnInitialLoad()
  },
  data: function () {
    return {
      showAlertDialog: false,
      errorMsg: '',
      tempOptionArr: [],
      totalOptions: 1,
      maxBuckets: 20,
      mcqType: 0,
      showConfirmationBox: false,
      prefixString: 'It will be deleted permanently.',
      postString: '\nAre you sure you want to delete the progress bucket?'
    }
  },
  components: {
    'confirmation-alert': ConfirmationOverlay,
    'alert-box': AlertBox
  },
  methods: {
    checkCertificateFileExtesion: function (fileName) {
      var exts = ['.pdf']
      return new RegExp('(' + exts.join('|').replace(/\./g, '\\.') + ')$').test(
        fileName
      )
    },
    addprogressBucketObjOnInitialLoad: function () {
      // AK: create new progressBucketObj
      var progressBucketObj = {
        ProgressBucketId: '',
        ProgressBucketName: '',
        MinValue: '',
        MaxValue: '',
        AllowToAddNextBucket: true
      }
      // AK: add it to tempOptionArr
      this.tempOptionArr.push(progressBucketObj)
      console.log('this.tempOptionArr >>>> ' + JSON.stringify(this.tempOptionArr))
    },
    addNewOption: function () {
      console.log('BEFORE ADD NEW  : ', this.tempOptionArr)
      if (this.tempOptionArr[this.totalOptions - 1].ProgressBucketName.length === 0) {
        this.showAlertDialog = true
        this.errorMsg = 'To add next bucket, please provide name for the current progress bucket.'
        return
      } else if (this.tempOptionArr[this.totalOptions - 1].MinValue.length === 0) {
        this.showAlertDialog = true
        this.errorMsg = 'To add next bucket, please provide min value for the current progress bucket.'
        return
      } else if (this.tempOptionArr[this.totalOptions - 1].MaxValue.length === 0) {
        this.showAlertDialog = true
        this.errorMsg = 'To add next bucket, please provide max value for the current progress bucket.'
        return
      }
      if (this.totalOptions !== this.maxBuckets) {
        // AK: Remove allow to add next option from current progressBucketObj
        this.tempOptionArr[this.totalOptions - 1].AllowToAddNextBucket = false
        // AK: Added new object
        this.totalOptions += 1
        this.addprogressBucketObjOnInitialLoad()
      } else {
        this.showAlertDialog = true
        this.errorMsg = 'Bucket limit exceeded.'
      }
      console.log('AFTER ADD NEW  : ', this.tempOptionArr)
    },
    removeOption: function (event, currentIndex) {
      if (this.totalOptions !== 1) {
        if (currentIndex === this.totalOptions) {
          // AK: IF user removed last option then show Add button previous option
          this.tempOptionArr[currentIndex - 2].AllowToAddNextBucket = true
        }
        // AK: Remove given option from Array
        this.udpatedTempArrAfterDelete(currentIndex - 1)
        this.totalOptions -= 1
      } else {
        this.showAlertDialog = true
        this.errorMsg = 'To create a Group, at least one Progress Bucket is required.'
      }
    },
    updateShowAlertDialogFlag (value) {
      this.showAlertDialog = value
    },
    udpatedTempArrAfterDelete: function (indexToRemove) {
      this.tempOptionArr.splice(indexToRemove, 1)
      console.log('After Delete >>> ' + JSON.stringify(this.tempOptionArr))
    },
    updateShowConfirmationAlertFlag (value) {
      // AK: Used when user pressed close button of confrimation overlay
      this.showConfirmationBox = value
    },
    hasDuplicateBucketName (bucketObj) {
      var dupNameArr = lodash.filter(this.tempOptionArr, function (o) {
        return o.ProgressBucketName.toLowerCase() === bucketObj.ProgressBucketName.toLowerCase()
      })
      if (dupNameArr.length > 1) {
        return true
      } else {
        return false
      }
    },
    hasDuplicateMinValue (bucketObj) {
      // var i = 0
      var dupNameArr = lodash.filter(this.tempOptionArr, function (o) {
        // i += 1
        // if (i !== 1) {
        return parseInt(o.MinValue) === parseInt(bucketObj.MinValue)
        // }
      })
      if (dupNameArr.length > 1) {
        return true
      } else {
        return false
      }
    },
    hasDuplicateMaxValue (bucketObj) {
      var dupNameArr = lodash.filter(this.tempOptionArr, function (o) {
        return parseInt(o.MaxValue) === parseInt(bucketObj.MaxValue)
      })
      if (dupNameArr.length > 1) {
        return true
      } else {
        return false
      }
    },
    hasMinValueOf0 () {
      var dupNameArr = lodash.filter(this.tempOptionArr, function (o) {
        return parseInt(o.MinValue) === 0
      })
      if (dupNameArr.length === 0) {
        return false
      } else {
        return true
      }
    },
    hasMaxValueOf100 () {
      var dupNameArr = lodash.filter(this.tempOptionArr, function (o) {
        return parseInt(o.MaxValue) === 100
      })
      if (dupNameArr.length === 0) {
        return false
      } else {
        return true
      }
    },
    hasMinValueOf100 () {
      var i = 0
      var _this = this
      var dupNameArr = lodash.filter(this.tempOptionArr, function (o) {
        i += 1
        if (i !== _this.tempOptionArr.length) {
          return parseInt(o.MinValue) === 100
        }
      })
      if (dupNameArr.length === 0) {
        return false
      } else {
        return true
      }
    },
    hasMaxValueOf1 () {
      var dupNameArr = lodash.filter(this.tempOptionArr, function (o) {
        return parseInt(o.MaxValue) === 1
      })
      if (dupNameArr.length === 0) {
        return false
      } else {
        return true
      }
    },
    hasMaxValueGreaterThan100 () {
      var dupNameArr = lodash.filter(this.tempOptionArr, function (o) {
        return parseInt(o.MaxValue) > 100
      })
      if (dupNameArr.length === 0) {
        return false
      } else {
        return true
      }
    },
    hasMinValueGreaterThan100 () {
      var dupNameArr = lodash.filter(this.tempOptionArr, function (o) {
        return parseInt(o.MinValue) > 100
      })
      if (dupNameArr.length === 0) {
        return false
      } else {
        return true
      }
    },
    hasMinValueLessThan0 () {
      var dupNameArr = lodash.filter(this.tempOptionArr, function (o) {
        return parseInt(o.MinValue) < 0
      })
      if (dupNameArr.length === 0) {
        return false
      } else {
        return true
      }
    },
    hasMaxValueLessThan1 () {
      var i = 0
      var dupNameArr = lodash.filter(this.tempOptionArr, function (o) {
        // return parseInt(o.MaxValue) < 1
        i += 1
        if (i !== 1) {
          return parseInt(o.MaxValue) < 1
        }
      })
      if (dupNameArr.length === 0) {
        return false
      } else {
        return true
      }
    },
    hasMinEmptyValue () {
      var dupNameArr = lodash.filter(this.tempOptionArr, function (o) {
        return (o.MinValue.trim().length === 0)
      })
      if (dupNameArr.length === 0) {
        return false
      } else {
        return true
      }
    },
    hasMaxEmptyValue () {
      var dupNameArr = lodash.filter(this.tempOptionArr, function (o) {
        return (o.MaxValue.trim().length === 0)
      })
      if (dupNameArr.length === 0) {
        return false
      } else {
        return true
      }
    },
    isGroupNameAlreadyExists () {
      var groupList = this.$store.state.groupList
      var _this = this
      var dupNameArr = lodash.filter(groupList, function (o) {
        return (o.GroupName.trim().toLowerCase() === _this.groupName.trim().toLowerCase())
      })
      if (dupNameArr.length === 0) {
        return false
      } else {
        return true
      }
    }
  },
  computed: {
    certificationTitleValue: {
      get: function () {
        return this.certificateTitle
      }
    },
    certificationDateValue: {
      get: function () {
        return this.certificationDate
      }
    }
  },
  watch: {
    createBtnPressed: function () {
      console.log('CREATE BUTTON PRESSED : ')
      //  var regex = /^[0]+:[0]+$/g
      if (this.groupName.trim().length === 0) {
        this.errorMsg = 'Group Name can\'t be empty.'
        this.showAlertDialog = true
        this.$emit('addBuckets', false)
      } else if (parseInt(this.maxElectiveEnrollmentCount) > 0 && (this.cohortName === undefined || this.cohortName === 'undefined' || this.cohortName === null || this.cohortName === 'null' || this.cohortName === '' || this.cohortName.trim().length === 0)) {
        this.showAlertDialog = true
        this.errorMsg = 'Cohort Name can\'t be empty.'
        this.$emit('addBuckets', false)
      } else if (this.minActionCount === 0 && this.maxActionCount > 0) {
        this.showAlertDialog = true
        this.errorMsg = 'Min action count can\'t be empty.'
        this.$emit('addBuckets', false)
      } else if (this.minActionCount > 0 && this.maxActionCount === 0) {
        this.showAlertDialog = true
        this.errorMsg = 'Max action count can\'t be empty.'
        this.$emit('addBuckets', false)
      } else if (this.minActionCount > this.maxActionCount) {
        this.showAlertDialog = true
        this.errorMsg = 'Min action count can\'t be greater than Max action count value.'
        this.$emit('addBuckets', false)
      } else if (this.showUnreleasedModuleMessage && (this.unreleasedModuleMessage === undefined || this.unreleasedModuleMessage === 'undefined' || this.unreleasedModuleMessage === null || this.unreleasedModuleMessage === 'null' || this.unreleasedModuleMessage === '' || this.unreleasedModuleMessage.trim().length === 0)) {
        this.showAlertDialog = true
        this.errorMsg = 'Unreleased lesson message can\'t be empty.'
        this.$emit('addBuckets', false)
      } else if (this.isGroupNameAlreadyExists()) {
        this.errorMsg = 'Group Name already exists.'
        this.showAlertDialog = true
        this.$emit('addBuckets', false)
      } else {
        // AK: Check weather last option filled or not
        if (this.tempOptionArr[this.totalOptions - 1].ProgressBucketName.trim().length === 0) {
          this.showAlertDialog = true
          this.errorMsg = this.tempOptionArr.length > 1 ? 'Please fill in last progress bucket name or remove the bucket.' : 'Please fill progress bucket name.'
          this.$emit('addBuckets', false)
        } else {
          var optLength = this.tempOptionArr.length
          var validationPassed = true
          //  HB: Check if there are any duplicate names for progress buckets
          for (var i = 0; i < optLength; i++) {
            var currBucket = this.tempOptionArr[i]
            if (this.hasDuplicateBucketName(currBucket)) {
              this.showAlertDialog = true
              validationPassed = false
              this.errorMsg = 'Each progress bucket must have a unique name.'
              this.$emit('addBuckets', false)
              break
            }
            if (this.hasDuplicateMinValue(currBucket)) {
              this.showAlertDialog = true
              validationPassed = false
              this.errorMsg = 'Duplicate min value found. Make sure each progress bucket\'s min value is unique.'
              this.$emit('addBuckets', false)
              break
            }
            if (this.hasDuplicateMaxValue(currBucket)) {
              this.showAlertDialog = true
              validationPassed = false
              this.errorMsg = 'Duplicate max value found. Make sure each progress bucket\'s max value is unique.'
              this.$emit('addBuckets', false)
              break
            }
          }
          if (this.hasMinEmptyValue()) {
            this.showAlertDialog = true
            validationPassed = false
            this.errorMsg = 'Min values are compulsory in the progress buckets.'
            this.$emit('addBuckets', false)
          } else if (this.hasMaxEmptyValue()) {
            this.showAlertDialog = true
            validationPassed = false
            this.errorMsg = 'Max values are compulsory in the progress buckets.'
            this.$emit('addBuckets', false)
          } else if (this.hasMaxValueGreaterThan100()) {
            this.showAlertDialog = true
            validationPassed = false
            this.errorMsg = 'Max value of greater than 100 is not allowed in the progress buckets.'
            this.$emit('addBuckets', false)
          } else if (!this.hasMinValueOf0()) {
            this.showAlertDialog = true
            validationPassed = false
            this.errorMsg = 'Please add min value of 0 to one of the progress buckets.'
            this.$emit('addBuckets', false)
          } else if (!this.hasMaxValueOf100()) {
            this.showAlertDialog = true
            validationPassed = false
            this.errorMsg = 'Please add max value of 100 to one of the progress buckets.'
            this.$emit('addBuckets', false)
          } else if (this.hasMaxValueOf1()) {
            this.showAlertDialog = true
            validationPassed = false
            // this.errorMsg = 'Max value of 1 is not allowed in the progress buckets.'
            this.errorMsg = 'Except last bucket, Min value of 100 is not allowed in the progress buckets.'
            this.$emit('addBuckets', false)
          } else if (this.hasMinValueOf100()) {
            this.showAlertDialog = true
            validationPassed = false
            // this.errorMsg = 'Min value of 100 is not allowed in the progress buckets.'
            this.errorMsg = 'Except last bucket, Min value of 100 is not allowed in the progress buckets.'
            this.$emit('addBuckets', false)
          } else if (this.hasMinValueLessThan0()) {
            this.showAlertDialog = true
            validationPassed = false
            // this.errorMsg = 'Min value of less than 1 is not allowed in the progress buckets.'
            this.errorMsg = 'Min value of less than 0 is not allowed in the progress buckets.'
            this.$emit('addBuckets', false)
          } else if (this.hasMaxValueLessThan1()) {
            this.showAlertDialog = true
            validationPassed = false
            // this.errorMsg = 'Max value of less than 1 is not allowed in the progress buckets.'
            this.errorMsg = 'Except first bucket, Max value of less than 1 is not allowed in the progress buckets.'
            this.$emit('addBuckets', false)
          } else if (this.hasMinValueGreaterThan100()) {
            this.showAlertDialog = true
            validationPassed = false
            this.errorMsg = 'Min value of greater than 100 is not allowed in the progress buckets.'
            this.$emit('addBuckets', false)
          }

          if (validationPassed) {
            console.log('Validation Success')
            this.tempOptionArr.forEach(element => {
              this.$store.state.createProgressBuckets.push(
                {
                  ProgressBucketId: '',
                  MinValue: element.MinValue,
                  MaxValue: element.MaxValue,
                  ProgressBucketName: element.ProgressBucketName
                }
              )
            })
            this.$emit('addBuckets', true)
          }
        }
      }
    }
  }
}
</script>

<style scoped>
.animationload {
  height: 100%;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 10000;
}
.osahanloading {
  animation: 1.5s linear 0s normal none infinite running osahanloading;
  background: #fed37f none repeat scroll 0 0;
  border-radius: 50px;
  height: 50px;
  left: 50%;
  margin-left: -25px;
  margin-top: -25px;
  position: absolute;
  top: 50%;
  width: 50px;
}
.osahanloading::after {
  animation: 1.5s linear 0s normal none infinite running osahanloading_after;
  border-color: #85d6de transparent;
  border-radius: 80px;
  border-style: solid;
  border-width: 10px;
  content: "";
  height: 80px;
  left: -15px;
  position: absolute;
  top: -15px;
  width: 80px;
}
@keyframes osahanloading {
  0% {
    transform: rotate(0deg);
  }
  50% {
    background: #85d6de none repeat scroll 0 0;
    transform: rotate(180deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.white-BG {
  background-color: #ffffff;
}
.overlay-overall-width-100Perc {
  width: 100% !important;
}
.overlay-overall-width-0Perc {
  width: 0%;
}
.overlay {
  height: 100%;
  width: 0;
  position: fixed;
  z-index: 3;
  top: 0;
  left: 0;
  background-color: rgb(0, 0, 0);
  background-color: rgba(0, 0, 0, 0.75);
  overflow-x: hidden;
  /*transition: 0.5s;*/
}

.overlay-content {
  position: relative;
  top: 5%;
  width: 100%;
  text-align: center;
  margin-top: 30px;
}
.background-color-white {
  background-color: #ffffff !important;
}
.white-porition-overlay-width-80Perc {
  width: 80%;
}
.center-aligned-div {
  margin: 0 auto;
}

.overlay a {
  padding: 8px;
  text-decoration: none;
  font-size: 36px;
  color: #818181;
  display: block;
  transition: 0.3s;
}

.overlay a:hover,
.overlay a:focus {
  color: #f1f1f1;
}

.overlay .closebtn {
  position: absolute;
  top: 20px;
  right: 45px;
  font-size: 60px;
}
@media screen and (max-height: 450px) {
  .overlay a {
    font-size: 20px;
  }
  .overlay .closebtn {
    font-size: 40px;
    top: 15px;
    right: 35px;
  }
}
.close-text-font-style {
  color: #aaa;
  font-size: 30px;
}
.text-align-right {
  text-align: right;
}
.text-align-left {
  text-align: left !important;
}
.margin-right-2Perc {
  margin-right: 2%;
}
.width {
  width: 95%;
}
.create-lesson {
  overflow-y: hidden !important;
}
.background-gray {
  background-color: aqua;
}
.overflow-y-hidden {
  overflow-y: hidden !important;
}
.overflow-hidden {
  overflow: hidden;
}
.save-button-width {
  width: 60% !important;
}
.padding-Top-2Perc {
  padding-top: 2%;
}
.padding-Top-3Perc {
  padding-top: 3%;
}
.font-size-1-3vw {
  font-size: 1.3vw;
}
.font-size-21px {
  font-size: 21px;
}
.font-size-16px {
  font-size: 16px;
}
.text-align-left {
  text-align: left;
}
.input-group .icon-addon .form-control {
  border-radius: 0;
}

.icon-addon {
  position: relative;
  color: #555;
  display: block;
}

.icon-addon:after,
.icon-addon:before {
  display: table;
  content: " ";
}

.icon-addon:after {
  clear: both;
}

.icon-addon.addon-md .glyphicon,
.icon-addon .glyphicon,
.icon-addon.addon-md .fa,
.icon-addon .fa {
  position: absolute;
  z-index: 2;
  left: 10px;
  font-size: 14px;
  width: 20px;
  margin-left: -2.5px;
  text-align: center;
  padding: 8px 0;
  top: 1px;
}

.icon-addon.addon-lg .form-control {
  line-height: 1.33;
  height: 30px;
  border-radius: 15px;
  font-size: 13px;
  padding: 10px 16px 10px 40px;
}

.icon-addon.addon-sm .form-control {
  height: 30px;
  padding: 5px 10px 5px 28px;
  font-size: 12px;
  line-height: 1.5;
}

.icon-addon.addon-lg .fa,
.icon-addon.addon-lg .glyphicon {
  font-size: 14px;
  margin-left: 0;
  left: 11px;
  top: 0px;
}

.icon-addon.addon-md .form-control,
.icon-addon .form-control {
  padding-left: 30px;
  float: left;
  font-weight: normal;
}

.icon-addon.addon-sm .fa,
.icon-addon.addon-sm .glyphicon {
  margin-left: 0;
  font-size: 12px;
  left: 5px;
  top: -1px;
}

.icon-addon .form-control:focus + .glyphicon,
.icon-addon:hover .glyphicon,
.icon-addon .form-control:focus + .fa,
.icon-addon:hover .fa {
  color: #2580db;
}
.background-gray {
  background-color: #ddd;
}
.border-rounded {
  border-bottom-right-radius: 12.5%;
  border-top-left-radius: 12.5%;
  border-top-right-radius: 12.5%;
  border-bottom-left-radius: 12.5%;
}
.gray-border {
  border: 1px solid #aaa;
}
.lesson-box-border {
  border: 1px solid #dddddd;
}
.vertical-align {
  display: flex;
  align-items: center;
}
.center-align-div {
  margin: 0 auto;
}
.margin-left-3Perc {
  margin-left: 3% !important;
}
.switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 30px;
}

.switch input {
  display: none;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 23px;
  width: 23px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

input:checked + .slider {
  background-color: #32cd32;
}

input:focus + .slider {
  box-shadow: 0 0 1px #32cd32;
}

input:checked + .slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}

/* Rounded sliders */
.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}
.border-color-red {
  border: 1px solid red;
}
.border-color-yellow {
  border: 1px solid yellow;
}
.create-lesson-input-text-style {
  color: #34495e;
  font-size: 14px;
}
.margin-bottom-2Perc {
  margin-bottom: 2%;
}
.create-lesson-overlay-button-BG {
  background-color: #f39c12 !important;
  border: 1px solid #f39c12 !important;
}
.create-lesson-overlay-button-width {
  width: 20%;
}
.black-font-color {
  color: #000;
}
.cursor-pointer {
  cursor: pointer;
}
.close-img-width-height {
  width: 5%;
  height: 5%;
}
.margin-top-3Perc {
  margin-top: 3%;
}
.margin-top-0Point7Perc {
  margin-top: 0.7%;
}
.margin-top-0Point5Perc {
  margin-top: 0.5%;
}
.float-right {
  float: right;
}
.font-color-blue {
  color: #34495e;
}
.font-weight-bold {
  font-weight: bold;
}

.margin-right-3Perc {
  margin-right: 3%;
}
.margin-left-2Perc {
  margin-left: 2% !important;
}
.padding-bottom-1Perc {
  padding-bottom: 1%;
}
.bottom-border {
  border-bottom: 1px solid #ddd;
  width: 96%;
}
.font-wight-bold {
  font-weight: bold;
}
.create-element-overlay-course-title-font-styles {
  font-size: 14px;
  color: #34495e;
}
.create-element-overlay-module-title-font-styles {
  font-size: 20px;
  color: #34495e;
}
.margin-Top-1Point5Perc {
  padding-top: 1.5%;
}
.padding-left-4Point4 {
  padding-left: 4.4%;
}
.padding-right-0px{
  padding-right: 0px !important;
}
.padding-left-0px{
  padding-left: 0px !important;
}
.font-size-12px{
  font-size: 12px;
}
.glyphicon {
    font-size: 25px;
}
.border-red{
  border: 1px solid red;
}
.padding-top-0Point6Perc{
  padding-top:0.6%;
}
</style>


// WEBPACK FOOTER //
// src/components/AddProgressBucket.vue